// extracted by mini-css-extract-plugin
module.exports = {"container":"Journal_container__e3WPF","date":"Journal_date__OyskG","link":"Journal_link__OixDs","description":"Journal_description__JEJn8"};